import React from 'react';
import './MenuItemPriceBlock.css';

export interface MenuItemPriceBlockProps {
  effectivePrice: number;
  strikeThroughPrice?: number | null;
  discountPercentage: number;
  sellingPrice: number;
  formatPrice: (price: number) => string;
}

const MenuItemPriceBlock: React.FC<MenuItemPriceBlockProps> = ({
  effectivePrice,
  strikeThroughPrice,
  discountPercentage,
  sellingPrice,
  formatPrice,
}) => {
  const hasDiscount =
    strikeThroughPrice != null && strikeThroughPrice > effectivePrice;

  return (
    <div className="menu-item-price-block">
      <div className="menu-item-price-block__row">
        <span className="menu-item-price-block__price">{formatPrice(effectivePrice)}</span>
        {hasDiscount && (
          <span className="menu-item-price-block__mrp">{formatPrice(strikeThroughPrice)}</span>
        )}
        {discountPercentage > 0 && (
          <span className="menu-item-price-block__off">{discountPercentage}% off</span>
        )}
        {!discountPercentage && sellingPrice !== effectivePrice && (
          <span className="menu-item-price-block__off">Deal</span>
        )}
      </div>
    </div>
  );
};

export default MenuItemPriceBlock;
